<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class="ri-file-shield-2-line me-1 text-primary"></i>Course Report
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3 ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" ngbTooltip="Select Course Test."
                                        placement="top" container="body">
                                        <i class='bx bx-book-reader'></i>
                                    </span>
                                    <select id="course" class="form-select border-start-0"
                                        [ngClass]="{'no-event': isLoading}" [(ngModel)]="courseId"
                                        (change)="onCourseChange($event)">
                                        <option *ngFor="let course of courses" [value]="course.id">
                                            {{ getTruncatedName(course.name ?? '', 25) }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3 ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" ngbTooltip="Select Course Test."
                                        placement="top" container="body">
                                        <i class='bx bx-book-reader'></i>
                                    </span>
                                    <select id="courseTest" class="form-select border-start-0"
                                        [ngClass]="{'no-event': isLoading}" [(ngModel)]="courseTestId"
                                        (change)="onCourseTestChange()">
                                        <option *ngFor="let courseTest of courseTests" [value]="courseTest.id">
                                            {{ getTruncatedName(courseTest.name ?? '', 25) }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="200">Name</th>
                                    <th scope="col" width="200">Code</th>
                                    <th scope="col" width="200">Title</th>
                                    <th scope="col" width="200">Start Date</th>
                                    <th scope="col" width="200">End Date</th>
                                    <th scope="col" width="200" class="text-center">Passing Score</th>
                                    <th scope="col" width="100" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let courseReport of courseReports; let i=index">
                                    <td>{{i+1}}.</td>
                                    <td>{{ courseReport.name }}</td>
                                    <td>{{ courseReport.code }}</td>
                                    <td>{{ courseReport.title }}</td>
                                    <td>{{ courseReport.startDate | date:'MMM dd, yyyy' }}</td>
                                    <td>{{ courseReport.endDate | date:'MMM dd, yyyy' }}</td>
                                    <td class="text-center">{{ courseReport.passingScore }}</td>
                                    <td class="actions">
                                        <i class="bx bx-show alert-info ms-2" title="View report"
                                            (click)="viewEmployeeReport(employeeReport)">
                                        </i>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="8">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container
                                            *ngIf="courseReports && courseReports.length < 1; else noSearchResults">
                                            <td colspan="8">No course reports were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="8"
                                                *ngIf="searchKeyword && (courseReports | search : 'name' : searchKeyword).length == 0">
                                                No course reports were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>